import { Url, URLS } from '@wix/da-url';
import { ModalType } from '../Modals/redux/types';
var submitMenuItems = [
    {
        type: 'deviation',
        label: 'siteHeader.deviation',
        link: Url.buildFromPath(URLS.SUBMIT),
        showDaProtect: true,
        svg: 'il29_-_deviation_v3.svg',
        svgSmallerSubmit: 'il6_2_2022.svg',
    },
    {
        type: 'status',
        label: 'siteHeader.statusUpdate',
        verificationAction: 'submitstatus',
        modalType: ModalType.STATUS_UPDATE,
        svg: 'il30_-_status_update_v3.svg', // IL6.8
    },
    {
        type: 'journal',
        label: 'siteHeader.journal',
        verificationAction: 'submitjournal',
        modalType: ModalType.JOURNAL,
        svg: 'il31_-_journal_v3.svg', // IL6.3
    },
    {
        type: 'post',
        label: 'siteHeader.post',
        link: Url.browseHomeLink('posts'),
        svg: 'il31_-_journal_v3.svg',
        svgSmallerSubmit: 'il6_3_2022.svg',
    },
    {
        type: 'literature',
        label: 'siteHeader.literature',
        modalType: ModalType.LITERATURE,
        svg: 'il32_-_literature_v3.svg',
        svgSmallerSubmit: 'il6_4_2022.svg',
    },
    {
        type: 'commission',
        label: 'siteHeader.commission',
        verificationAction: 'submitcommission',
        modalType: ModalType.COMMISSION,
        modalOptions: {
            params: { redirectOnSubmit: true },
        },
        svg: 'il62_-_commission_v3.svg',
        svgSmallerSubmit: 'il6_1_2022.svg',
    },
    {
        type: 'poll',
        label: 'siteHeader.poll',
        verificationAction: 'submitpoll',
        modalType: ModalType.POLL_EDIT,
        svg: 'il33_-_poll_v3.svg', // IL6.7
    },
    {
        type: 'tier',
        label: 'siteHeader.tier',
        link: URLS.ROOT,
        modalType: ModalType.TIER_EDIT,
        modalOptions: {
            wrapInModal: false,
        },
        isNew: true,
        svg: 'il6_9_-_tip_jar.svg',
        svgSmallerSubmit: 'il6_9_2022.svg',
    },
    {
        type: 'dreamup',
        label: 'siteHeader.dreamup',
        link: Url.dreamupLink(),
        isNew: true,
        showNewByTitle: true,
        svg: 'il6_10_-_dreamup.svg',
        svgSmallerSubmit: 'il6_10_2022.svg',
    },
];
export var desktopSubmitMenuItems = submitMenuItems;
// mobile has fewer items in different order
export var mobileSubmitMenuItems = [
    'deviation',
    'status',
    'poll',
    'commission',
    'dreamup',
].map(function (type) { return submitMenuItems.find(function (item) { return item.type === type; }); });
export var submitButtonMenuItem = {
    type: 'submitbutton',
    link: Url.buildFromPath(URLS.SUBMIT),
};
//# sourceMappingURL=constants.js.map